import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import SuccessModal from './components/SuccessModal';
import Events from './components/Events';
import Guidelines from './components/Guidelines';
import Coordinators from './components/Coordinators';
import Partners from './components/Partners';
import Sponsors from './components/Sponsors';
import Footer from './components/Footer';
import EventBanner from './components/EventBanner';
import EventPage from './pages/events/EventPage';
import './App.css';

// Wrapper component to handle scroll behavior
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Scroll to top when path changes
    window.scrollTo(0, 0);
  }, [pathname]);

  // Handle hash-based scrolling
  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        const headerOffset = 100; // Adjust based on your header height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [hash]);

  return null;
};

function AppContent() {
  const location = useLocation();
  const isEventPage = location.pathname.startsWith('/events/');
  
  return (
    <div className="App background-fixed">
      <Navbar isEventPage={isEventPage} />
      <SuccessModal />
      <main className="App-content">
        <Routes>
          <Route path="/" element={
            <>
              <Home />
              <About />
              <Events />
              <Guidelines />
              <Coordinators />
              <Partners />
              <Sponsors />
              <Footer />
              <EventBanner />
            </>
          } />
          <Route path="/events/:eventId" element={<EventPage />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
